import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'

const MetaTags = ({ resolvedUrl, articleClassification, article }) => {
  const pathName = resolvedUrl.split('?')[0]

  const title =
    articleClassification?.meta?.title || articleClassification?.name
  const metaTitle = `${title} - 信義居家`
  const description = articleClassification?.meta?.describe
  const keywords = articleClassification?.keywords
    ?.map((keyword) => keyword.name)
    .join(',')

  const breadcrumbData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首頁',
        item: 'https://livinglife.com.tw',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '找好文',
        item: 'https://livinglife.com.tw/article',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: articleClassification?.name,
        item: LS_APP_DOMAIN + pathName,
      },
    ],
  }

  return (
    <Head>
      <title>{metaTitle}</title>

      <link
        key="canonical"
        rel="canonical"
        href={`${LS_APP_DOMAIN + pathName}`}
      />

      {/* For Google */}
      <meta key="title" name="title" content={metaTitle} />
      <meta key="description" name="description" content={description} />
      <meta key="keywords" name="keywords" content={keywords} />

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={metaTitle} />
      <meta
        key="og:description"
        property="og:description"
        content={description}
      />
      <meta
        key="og:url"
        property="og:url"
        content={`${LS_APP_DOMAIN + pathName}`}
      />
      <meta
        key="og:image"
        property="og:image"
        content={article?.image?.url || ''}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </Head>
  )
}

export default MetaTags
